module.exports = __webpack_public_path__ + "img/ScaledAccess-AccessFeatures-Icon-ConsentManagement.svg";